// extracted by mini-css-extract-plugin
module.exports = {"glossaryDetailsErrorBlock":"style_glossaryDetailsErrorBlock__2ApU0"};